'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = require('./helpers/util');

exports.default = function (date) {
  return (0, _util.checkDate)(date) && (0, _util.checkNaN)(date.getTime()) === false;
}; //@flow weak


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/isValid.js
// module id = 1367
// module chunks = 0 1 2 3 4 5 7 8 9